import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
export default class SwiperJs {
    constructor() {
        this.swiperSimple = document.querySelectorAll('.swiper-default');
        this.initSimple();
    }
    initSimple() {
        this.swiperSimple.forEach((sliderContainer) => {
            const slider = sliderContainer.querySelector('.swiper');
            const navigationEl = sliderContainer.querySelector('.swiper-button-prev');
            const paginationEl = sliderContainer.querySelector('.swiper-pagination');
            const loop = sliderContainer.hasAttribute('data-loop');
            const autoplay = sliderContainer.hasAttribute('data-autoplay');
            let options = {
                spaceBetween: 8,
                slidesPerView: 1,
                loop: loop,
                autoplay: autoplay,
                modules: [],
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 16
                    },
                    744: {
                        slidesPerView: 3,
                        spaceBetween: 24
                    }
                }
            };
            if (autoplay) {
                options.modules.push(Autoplay);
            }
            if (navigationEl) {
                const navigationNextEl = sliderContainer.querySelector('.swiper-button-next');
                const navigationPrevEl = sliderContainer.querySelector('.swiper-button-prev');
                options.modules.push(Navigation);
                options["navigation"] = {
                    nextEl: navigationNextEl,
                    prevEl: navigationPrevEl
                };
            }
            if (paginationEl) {
                options.modules.push(Pagination);
                options["pagination"] = {
                    el: paginationEl,
                    clickable: true
                };
            }
            new Swiper(slider, options);
        });
    }
}
